import { Component, OnInit, ViewChild } from '@angular/core';
import { DataGridSettingModel } from 'src/app/models/data-grid.model';
import { CalendarOptions, Calendar } from '@fullcalendar/core';
import { MatDialog } from '@angular/material/dialog';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import mkLocale from '@fullcalendar/core/locales/mk';
import { AddPriorityWorkDayConfig, AddPriorityWorkDayConfigs, AdministrationResultStatus, ConfigurationParameterData, DayData, EmployeeData, HolidayData, PaginationArgs, PeriodicScheduleEntriesResultData, PeriodicScheduleEntryData, PeriodicScheduleGroupsAvailabilityArgs, PreloadCyclicTypeEnum, PriorityWorkDayConfigData, ReplaceEmployeeData, ScheduleData, ShiftTemplateData, TermData, TermSearchArgs, UpdateScheduleData, UserProfileData, WorkDayConfigData } from 'src/app/clients/system-api/SystemApiClient';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ScheduleService } from 'src/app/services/schedule.service';
import { ConfigurationParameterService } from 'src/app/services/configuration-parameter.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ShiftTemplateService } from 'src/app/services/shift-template.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { PriorityWorkDayConfigService } from 'src/app/services/priority-work-day-config.service';
import { CalendarRefreshService } from 'src/app/services/calendar.service';
import { DeleteComponent } from 'src/app/components/delete-component/delete-component.component';
import { HolidayService } from 'src/app/services/holiday.service';
import { WindowDimensions, WindowDimensionsService } from 'src/app/services/window-dimension-service.service';
import * as moment from 'moment';
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { TranslateService } from '@ngx-translate/core';
import { MatSelectChange } from '@angular/material/select';
import { TermService } from 'src/app/services/term.service';
import { cloneDeep } from 'lodash';

const TITLE_LIMIT = 2;
const DEFAULT_OPACITY = 0.5;
const MAX_STORED_COLORS = 10;
const COMMON_SPLITTER = '-'
export const WIDTH_CHANGE_THRESHOLD = 250;

export function getRandomInRange(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

@Component({
  selector: 'app-contract-request-list',
  templateUrl: './shift-page.component.html',
  styleUrls: ['./shift-page.component.scss']
})
export class ShiftPageComponent implements OnInit {
  shiftTemplateId?: number;
  searchForm!: FormGroup;
  dataGridSettings!: DataGridSettingModel;

  windowDimensions: WindowDimensions = {} as WindowDimensions;
  addEmployeeShiftInPriorityWorkDay: AddPriorityWorkDayConfigs = new AddPriorityWorkDayConfigs();
  shiftTemplateData: ShiftTemplateData[] | undefined = [];

  configurationParameterData: ConfigurationParameterData | undefined;
  userProfileData: UserProfileData[] | undefined = [];
  holidayData: HolidayData[] | undefined = [];

  employeeProfileId: number | undefined;
  employeeData: UserProfileData[] | undefined = [];

  replaceEmployeeData: ReplaceEmployeeData | undefined = new ReplaceEmployeeData()
  replacedEmployeeData: UserProfileData[] | undefined = [];
  replacementEmployeeData: UserProfileData[] | undefined = [];
  filteredReplacementEmployeeData: UserProfileData[] | undefined = [];

  selectedDateRange: { start: Date, end: Date } | null = null;

  currentDate: Date = new Date();
  firstDate: Date | undefined = undefined;
  lastDate: Date | undefined = undefined;

  totalMinutesDifference = 0;
  removeExist: boolean = false;
  showConfirmation: boolean = false;
  title: any;
  arg: any

  sortedWorkingHours: { [key: number]: { [key: number]: WorkDayConfigData[][]; } } = {};
  lastWidthBrakePoint:number | undefined = undefined;

  //PopUps
  addShiftTemplatePopupState: boolean = false;
  editShiftTemplatePopupState: boolean = false;
  deleteShiftTemplatePopupState: boolean = false;
  addShiftPopupState:boolean = false;
  editShiftPopupState:boolean = false;
  allowEmployeeSwap: boolean = true;
  hasChoseEmployeeToReplace: boolean = false;
  editEmployeeSchedulePopup: boolean = false;
  deleteEmployeeSchedulePopup: boolean = false;

  //Calendar
  periodicScheduleGroupsAvailabilityArgs: PeriodicScheduleGroupsAvailabilityArgs = new PeriodicScheduleGroupsAvailabilityArgs();
  currentEvents: any[] = [];
  holidayEvents: any[] = [];
  addingEvents: any[] = [];
  lastLoadedEndDate: Date | undefined = undefined;
  firstLoadedStartDate: Date | undefined = undefined;
  initialNextLoad: boolean = true;
  weekPosition: number = 0;
  serviceName: string = "";
  internalPreviewPopupStartTime: Date | undefined = undefined;
  internalPreviewPopupEndTime: Date | undefined = undefined;
  fullCalendarApi: Calendar | undefined = undefined;

  employeeColorMap: Record<number, string> = {};
  generatedColors = new Set<string>();

  minimumHourInView: moment.Moment | undefined = undefined;
  maximumHourInView: moment.Moment | undefined = undefined;
  previousMinimumHourInView: moment.Moment | undefined = undefined;
  previousMaximumHourInView: moment.Moment | undefined = undefined;
  periodicScheduleEntriesResultData: PeriodicScheduleEntriesResultData | undefined = undefined;
  paginationArgs: PaginationArgs = new PaginationArgs();
  cyclicPeriodLength: number = 0;
  preloadAmount: number = 0;
  calendarOptions: CalendarOptions = { initialView: 'timeGridWeek', plugins: [dayGridPlugin, timeGridPlugin], };
  initialCalendarSetup: boolean = true;

  paginationOptions = { clickable: true, dynamicBullets: false };

  employeeScheduleDataMap: { [key: number]: ScheduleData[] } = {};
  editingSchedule: ScheduleData | undefined = undefined;
  termsToCancel: TermData[] | undefined = undefined;

  updatingScheduleData: UpdateScheduleData = new UpdateScheduleData();
  today: Date = new Date();

  editingWorkDayScheduleWorkingState: boolean = true;

  @ViewChild('searchNgForm') searchNgForm!: NgForm;
  @ViewChild(GenericModalComponent) genericModalComponent!: GenericModalComponent;
  @ViewChild('template') template!: any;
  @ViewChild('calendar') fullCalendarComponent!: FullCalendarComponent;
  @ViewChild('editShiftPopup') EditShiftPopup!: GenericModalComponent;
  @ViewChild('deleteEmployeeSchedulePopup') DeleteEmployeeSchedulePopup!: GenericModalComponent;
  @ViewChild('editEmployeeSchedulePopup') EditEmployeeSchedulePopup!: GenericModalComponent;

  constructor(
    public translateService: TranslateService,
    private priorityWorkDayConfigService: PriorityWorkDayConfigService,
    private scheduleService: ScheduleService,
    private employeeService: EmployeeService,
    private termService: TermService,
    private holidayService: HolidayService,
    private shiftTemplateService: ShiftTemplateService,
    private configurationParameterService: ConfigurationParameterService,
    private _windowDimensionService: WindowDimensionsService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private calendarRefreshService: CalendarRefreshService
  ) {
    
    this._windowDimensionService
    .getWindowDimensions$()
    .subscribe((dimensions) => {
      this.windowDimensions = dimensions;

      if(this.fullCalendarComponent !== undefined){
        if(this.fullCalendarApi !== undefined){
          if(this.windowDimensions.width < this.windowDimensions.threshold_lg){
            this.fullCalendarApi.changeView('timeGridDay');
          } else {
            this.fullCalendarApi.changeView('timeGridWeek');
          }
        }
      }

      if(this.lastWidthBrakePoint === undefined || Math.abs(this.windowDimensions.width - this.lastWidthBrakePoint) > WIDTH_CHANGE_THRESHOLD){
        if(this.lastWidthBrakePoint !== undefined){
          if(this.fullCalendarApi !== undefined){
            setTimeout(() => {
              if(this.fullCalendarApi !== undefined){ this.fullCalendarApi.updateSize(); }
            }, 500);
          }
        }
        this.lastWidthBrakePoint = this.windowDimensions.width;
      }
    });
  }

  public translate(key: string) {
    return this.translateService.instant(key);
  }

  ngOnInit(): void {
    this.searchForm = this._formBuilder.group({
      program: ['', Validators.required],
      active: [''],
    })

    this.paginationArgs = new PaginationArgs();
    this.paginationArgs.skipCount = 0;
    this.paginationArgs.maxResultCount = 9999;
    this.paginationArgs.sorting = 'Id ASC';

    this.calendarOptions.initialView = this.windowDimensions.width < this.windowDimensions.threshold_lg ? 'timeGridDay' : 'timeGridWeek';

    this.shiftTemplateService.retrieveAllEmployeesWithServices(this.paginationArgs).subscribe((data) => {
      this.userProfileData = data.content?.items?.filter(x => x.roleId === 3); //RoleID: 3 - Employee za Fi4o
    });

    this.employeeService.retrieveAllUsers(3).subscribe((data) => {
      this.employeeData = data.content?.items;
    });

    this.configurationParameterService.retrieveActiveConfigurationParameter().subscribe(next => {
      this.configurationParameterData = next.content;
    });

    this.calendarRefreshService.refresh$.subscribe(() => {
      this.refreshCalendar();
    });

    this.retrieveAllShiftTemplates()
    
  }

  ngAfterViewInit(): void {
    if(this.fullCalendarComponent !== undefined){
      if(this.fullCalendarApi === undefined){ this.fullCalendarApi = this.fullCalendarComponent.getApi(); }
    }

    this.currentEvents = [];
    this.employeeScheduleDataMap = {};
    this.updatingScheduleData = new UpdateScheduleData();
    this.today = new Date(); this.today.setHours(0); this.today.setMinutes(0); this.today.setSeconds(0); this.today.setMilliseconds(0);
    this.editingWorkDayScheduleWorkingState = true;

    this.paginationArgs = new PaginationArgs();
    this.paginationArgs.skipCount = 0;
    this.paginationArgs.maxResultCount = 9999;
    this.paginationArgs.sorting = 'Id ASC';

    this.periodicScheduleGroupsAvailabilityArgs = new PeriodicScheduleGroupsAvailabilityArgs();
    this.periodicScheduleGroupsAvailabilityArgs.startDate = new Date();
    this.periodicScheduleGroupsAvailabilityArgs.includeFullScheduleData = false;
    this.periodicScheduleGroupsAvailabilityArgs.onlyActiveSchedules = true;

    var startHour = moment(new Date()); startHour.set('hour', 0); startHour.set('minute', 0);
    var endHour = moment(new Date()); endHour.set('hour', 23); endHour.set('minute', 59);
    this.updateCalendarOptions(startHour, endHour, []);

    this.generateCalendar(this.periodicScheduleGroupsAvailabilityArgs, true);

    this.retrieveAllEmployeeSchedules();
  }

  public retrieveAllShiftTemplates() {
      this.shiftTemplateService.retrieveAllShiftTemplates().subscribe(next => {
      this.shiftTemplateData = next.content;
      this.groupWorkingHourConfigs();
    });
  }

  public retrieveAllEmployeeSchedules(){
    this.scheduleService.retrieveAllActiveUnpassedEmployeeSchedulesBasic().subscribe((data) => {
      if(data.status === AdministrationResultStatus.Success && data.content !== undefined){
        let schedules = data.content;
        schedules.forEach((schedule) => { 
          if(schedule.employeeProfileId !== undefined){
            if(schedule.employeeProfileId in this.employeeScheduleDataMap){
              this.employeeScheduleDataMap[schedule.employeeProfileId].push(schedule);
            } else {
              this.employeeScheduleDataMap[schedule.employeeProfileId] = [schedule];
            }
          }
        });
      }
    });
  }

  //#region Popups
  public toggleAddShiftPopup(state?: boolean) {
    this.addShiftPopupState = false;
    this.addShiftPopupState = state ?? !this.addShiftPopupState;
  }

  public toggleEditShiftPopup(state?: boolean) {
    this.editShiftPopupState = state ?? !this.editShiftPopupState;
    this.hasChoseEmployeeToReplace = false;
    this.editingWorkDayScheduleWorkingState = true;
  }

  public toggleAddShiftTemplatePopup(state?: boolean) {
    this.editShiftTemplatePopupState = false;
    this.shiftTemplateId = undefined;
    this.addShiftTemplatePopupState = false;
    this.addShiftTemplatePopupState = state ?? !this.addShiftTemplatePopupState;
  }

  public toggleEditShiftTemplatePopup(state?: boolean, shiftTemplateId?:number) {
    this.addShiftTemplatePopupState = false;
    this.editShiftTemplatePopupState = false;
    this.editShiftTemplatePopupState = state ?? !this.editShiftTemplatePopupState;
    this.shiftTemplateId = shiftTemplateId;
  }

  public toggleEditEmployeeSchedulePopup(state?: boolean, schedule?: ScheduleData | undefined) {
    this.termsToCancel = undefined;

    this.editEmployeeSchedulePopup = state ?? !this.editEmployeeSchedulePopup;
    if(this.editEmployeeSchedulePopup === true && schedule !== undefined){
      this.updatingScheduleData = new UpdateScheduleData({
        scheduleId: schedule.id,
        employeeProfileId: schedule.employeeProfileId,
        startingFrom: schedule.startingFrom ?? new Date(),
        endOn: schedule.endOn ?? new Date(),
        workWeekList: undefined
      });

      this.editingSchedule = schedule;
    } else {
      this.editingSchedule = undefined;
    }
  }

  public toggleDeleteEmployeeSchedulePopup(state?: boolean, schedule?: ScheduleData | undefined) {
    this.termsToCancel = undefined;
    this.deleteEmployeeSchedulePopup = state ?? !this.editEmployeeSchedulePopup;
    if(this.deleteEmployeeSchedulePopup === true && schedule !== undefined){
      this.editingSchedule = schedule;
    } else {
      this.editingSchedule = undefined;
    }
  }

  public onCloseDeleteEmployeeSchedulePopup() {
    this.DeleteEmployeeSchedulePopup.handleClose();
  }

  public onCloseEditEmployeeSchedulePopup() {
    this.EditEmployeeSchedulePopup.handleClose();
  }

  public closeShiftPopup() {
    if(this.replaceEmployeeData !== undefined){ 
      this.replaceEmployeeData!.replacedEmployeeProfileId = undefined;
      this.replaceEmployeeData!.replacementEmployeeProfileId = undefined;
     }
     this.addShiftPopupState = false;
     this.hasChoseEmployeeToReplace = false;
     this.editShiftPopupState = false;
     
     this.genericModalComponent.handleClose(true);
  }

  public closeShiftTemplatePopup() {
    this.genericModalComponent.handleClose(true);
    this.addShiftTemplatePopupState = false;
    this.editShiftTemplatePopupState = false;
    this.deleteShiftTemplatePopupState = false;
    this.retrieveAllShiftTemplates()
  }

  public deleteShiftTemplate(shiftTemplateId: number | undefined) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      width: "66vh",
      data: {
        initialWidth: '66vh',
        id: shiftTemplateId,
        serviceName: 'shiftTemplate'
      },
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "submit") {
        this.retrieveAllShiftTemplates()
      }
    })
  }

  public toggleDeleteShiftTemplatePopup(state?: boolean, shiftTemplateId?:number, serviceName?: string) {
    this.deleteShiftTemplatePopupState = false;
    this.deleteShiftTemplatePopupState = state ?? !this.deleteShiftTemplatePopupState;
    this.shiftTemplateId = shiftTemplateId;
    this.serviceName =  serviceName!;
  }

  public onEmployeeToReplaceSelectionChange(event: MatSelectChange){
    this.hasChoseEmployeeToReplace = true;
    this.filteredReplacementEmployeeData = this.replacementEmployeeData?.filter(x => x.profileId !== event.value);
  }

  public async prepareDeleteEmployeeSchedule(schedule: ScheduleData | undefined): Promise<void>{
    if(schedule !== undefined){
    await new Promise<void>((resolve) => {    
      this.termService.retrieveTermsByTermSearchArgs(new TermSearchArgs({
        employeeProfileId: schedule.employeeProfileId,
        fromDate: schedule.startingFrom !== undefined && schedule.startingFrom > new Date() ? schedule.startingFrom : new Date(),
        toDate: schedule.endOn,
        includeCancelled: false,
        includePassedTerms: false,
        })).subscribe(async (result) => {
          if(result.status === AdministrationResultStatus.Success && result.content){
            this.termsToCancel = result.content;
          } else { 
            this.termsToCancel = undefined;
          }

          if(this.termsToCancel === undefined || this.termsToCancel.length <= 0){
            this.confirmDeleteEmployeeSchedule(schedule, undefined);
          }
        });
        resolve();
      });
    }
  }

  public async confirmDeleteEmployeeSchedule(schedule: ScheduleData | undefined, termsToCancel: TermData[] | undefined): Promise<void>{
    if(schedule !== undefined) {
      await new Promise<void>((resolve) => {
        this.scheduleService.deactivateSchedule(schedule.id!).subscribe(async (result) => {
          if(result === AdministrationResultStatus.Success){
            if(termsToCancel !== undefined && termsToCancel.length > 0){
              for (const term of termsToCancel) {
                if(term.id){ await this.cancelTerm(term.id); }
              }
            }
            this.snackBarService.callSnackBar(result, "Successfully deleted");
          } else {
            this.snackBarService.callSnackBar(result, "error");
          }
        });

        setTimeout(() => {
          this.DeleteEmployeeSchedulePopup.handleClose();
          this.ngAfterViewInit();
        }, 250);

        resolve();
      });
    }
  }

  public async prepareEditEmployeeSchedule(schedule: ScheduleData | undefined): Promise<void>{
    if(schedule !== undefined){
    await new Promise<void>(async (resolve) => {   
      this.today = new Date(); this.today.setHours(0); this.today.setMinutes(0); this.today.setSeconds(0); this.today.setMilliseconds(0);

      var startingFrom = moment(this.updatingScheduleData.startingFrom ?? (schedule.startingFrom ?? this.today)).utc(true).clone();
      startingFrom = moment(startingFrom.toDate() > this.today ? startingFrom : this.today).utc(true).clone();
      startingFrom = moment(startingFrom).utc(true).clone().clone();

      var endOn = startingFrom;
      if (schedule.endOn && schedule.endOn > endOn.toDate()) { endOn = moment(schedule.endOn).utc(true).clone(); }
      if (this.today > endOn.toDate()) { endOn = moment(this.today).utc(true).clone(); }
      endOn = moment(endOn).utc(true).clone();
      
      if(this.updatingScheduleData.startingFrom !== undefined && this.updatingScheduleData.endOn !== undefined
        && schedule.startingFrom !== undefined && schedule.endOn !== undefined){
        
        var originalStartingFrom = moment(schedule.startingFrom).utc(true).clone(); originalStartingFrom.hours(0); originalStartingFrom.minutes(0); originalStartingFrom.seconds(0); originalStartingFrom.milliseconds(0); 
        var originalEndOn = moment(schedule.endOn).utc(true).clone(); originalEndOn.hours(0); originalEndOn.minutes(0); originalEndOn.seconds(0); originalEndOn.milliseconds(0);
  
        var updatedStartingFrom = moment(this.updatingScheduleData.startingFrom).utc(true).clone(); updatedStartingFrom.hours(0); updatedStartingFrom.minutes(0); updatedStartingFrom.seconds(0); updatedStartingFrom.milliseconds(0);
        var updatedEndOn = moment(this.updatingScheduleData.endOn).utc(true).clone(); updatedEndOn.hours(0); updatedEndOn.minutes(0); updatedEndOn.seconds(0); updatedEndOn.milliseconds(0);

        
        // Check if the new schedule is within the bounds of the current schedule
        if(!(updatedStartingFrom <= originalStartingFrom && updatedEndOn >= originalEndOn)){
          this.termsToCancel = [];
          
          if(updatedStartingFrom > originalStartingFrom && updatedEndOn >= originalEndOn){
            startingFrom = originalStartingFrom;
            endOn = updatedStartingFrom;
            await this.findTermsToCancel(schedule, startingFrom, endOn).finally(() => {
              if(this.termsToCancel === undefined || this.termsToCancel.length <= 0){
                this.confirmEditEmployeeSchedule(schedule, undefined);
             }
            });
          } else if(updatedStartingFrom <= originalStartingFrom && updatedEndOn < originalEndOn){
            startingFrom = updatedEndOn;
            endOn = originalEndOn;
            await this.findTermsToCancel(schedule, startingFrom, endOn,).finally(() => {
              if(this.termsToCancel === undefined || this.termsToCancel.length <= 0){
                this.confirmEditEmployeeSchedule(schedule, undefined);
             }
            });
          } else if(updatedStartingFrom > originalStartingFrom && updatedEndOn < originalEndOn){
            await this.findTermsToCancel(schedule, originalStartingFrom, updatedStartingFrom).then(async () => {
              await this.findTermsToCancel(schedule, updatedEndOn, originalEndOn, cloneDeep(this.termsToCancel ?? [])).finally(() => {
                  if (this.termsToCancel === undefined || this.termsToCancel.length <= 0) {
                    this.confirmEditEmployeeSchedule(schedule, undefined);
                  }
              });
            });
          }
        } else {
          this.termsToCancel = undefined;
          this.confirmEditEmployeeSchedule(schedule, undefined);
        }
      }
        resolve();
      });
    }
  }

  private async findTermsToCancel(schedule: ScheduleData, startingFrom: moment.Moment, endOn: moment.Moment, initialTermsList: TermData[] = []): Promise<void> {
    return new Promise<void>((resolve) => {
      this.termService.retrieveTermsByTermSearchArgs(new TermSearchArgs({
          employeeProfileId: schedule.employeeProfileId,
          fromDate: moment(startingFrom).utc(true).toDate(),
          toDate: moment(endOn).utc(true).toDate(),
          includeCancelled: false,
          includePassedTerms: false,
      })).subscribe(async (result) => {
          if (result.status === AdministrationResultStatus.Success && result.content) {
            this.termsToCancel = cloneDeep(initialTermsList?.concat(result.content));
          }
          resolve();
      });
    });
  }

  public async confirmEditEmployeeSchedule(scheduel: ScheduleData, termsToCancel: TermData[] | undefined): Promise<void>{
    if(this.updatingScheduleData !== undefined) {
      this.updatingScheduleData.startingFrom = moment(this.updatingScheduleData.startingFrom).clone().utc(true).toDate();
      this.updatingScheduleData.endOn = moment(this.updatingScheduleData.endOn).utc(true).clone().toDate();
      this.updatingScheduleData.scheduleId = scheduel.id;
      this.updatingScheduleData.employeeProfileId = scheduel.employeeProfileId;

      await new Promise<void>((resolve) => {
        this.scheduleService.updateScheduleRange(this.updatingScheduleData).subscribe(async (result) => {
          if(result === AdministrationResultStatus.Success){
            if(termsToCancel !== undefined && termsToCancel.length > 0) {
              for (const term of termsToCancel) {
                if(term.id){ await this.cancelTerm(term.id); }
              }
            }
            this.snackBarService.callSnackBar(result, "Successfully entered");
          } else {
            this.snackBarService.callSnackBar(result, "error");
          }
        });

        setTimeout(() => {
          this.EditEmployeeSchedulePopup.handleClose();
          this.ngAfterViewInit();
        }, 250);

        resolve();
      });
    }
  }

  public findMinimumStartFromDate(schedule: ScheduleData | undefined){
    this.today = new Date(); this.today.setHours(0); this.today.setMinutes(0); this.today.setSeconds(0); this.today.setMilliseconds(0);

    if(schedule !== undefined && schedule.employeeProfileId !== undefined && this.employeeScheduleDataMap !== undefined){
      if(schedule.employeeProfileId in this.employeeScheduleDataMap){
        let minDate = moment(new Date(schedule.startingFrom ?? new Date())).utc(true).toDate();
        this.employeeScheduleDataMap[schedule.employeeProfileId].forEach((schedule) => {
          if(schedule.startingFrom !== undefined && moment(schedule.startingFrom).utc(true).clone().toDate() < minDate){
            minDate = moment(schedule.startingFrom).utc(true).clone().toDate();
          }
        });
        return moment(minDate > this.today ? minDate : this.today).utc(true).toDate();
      }
    }

    return moment(schedule?.startingFrom ?? new Date()).utc(true).toDate();
  }
  
  private async cancelTerm(termId: number): Promise<void> {
    return new Promise<void>((resolve) => {
      const sub = this.termService.cancelTerm(termId).subscribe((data) => {
        if (data === AdministrationResultStatus.Success) {
          resolve();
        } else {
          resolve();
        }
      });
      sub.add(() => sub.unsubscribe());
    });
  }

  public checkForKeyInEmployeeScheduleMap(employeeId: number | undefined){  
    if(employeeId === undefined){ return false; }
    if(employeeId in this.employeeScheduleDataMap){ return true; }
    return false;
  }
  //#endregion

  //#region Calendar
  private updateCalendarOptions(minHours: moment.Moment, maxHours: moment.Moment, events: any[] | undefined = undefined){
    let minimumHour = minHours < maxHours ? minHours : maxHours;
    let maximumHour = minHours > maxHours ? minHours : maxHours;
    
    if(this.initialCalendarSetup){
      this.translateService.get('Add schedule').subscribe((translated_key_1: string) => {     
        this.translateService.get('today').subscribe((translated_key_2: string) => {     
          this.calendarOptions = {
            timeZone: 'Europe/Skopje',
            firstDay: 1,
            weekNumberCalculation: 'ISO',
            slotMinTime: minHours.toDate().getHours().toString().padStart(2, '0') + ':' + minHours.toDate().getMinutes().toString().padStart(2, '0'),
            dayHeaderContent: (args) => {
              const dayNames = [
                this.translateService.instant('Sun').toUpperCase(),
                this.translateService.instant('Mon').toUpperCase(),
                this.translateService.instant('Tue').toUpperCase(),
                this.translateService.instant('Wed').toUpperCase(),
                this.translateService.instant('Thu').toUpperCase(),
                this.translateService.instant('Fri').toUpperCase(),
                this.translateService.instant('Sat').toUpperCase(), 
              ];
              const dayName = dayNames[moment(args.date).utc(true).clone().toDate().getDay()];
              const dayNumber = moment(args.date).utc(true).clone().toDate().getDate();
              return `${dayName} - ${dayNumber}`;
            },
            slotLabelFormat: { hour: 'numeric', minute: '2-digit', omitZeroMinute: false, meridiem: 'short', hour12: false, },
            height: "auto",
            themeSystem: 'bootstrap',
            slotMaxTime: maxHours.toDate().getHours().toString().padStart(2, '0') + ':' + maxHours.toDate().getMinutes().toString().padStart(2, '0'),
            allDaySlot: false,
            events: events || [],
            slotDuration: { hours: 1 },
            select: this.handleDateSelect.bind(this),
            eventClick: this.handleDateClick.bind(this),
            showNonCurrentDates: false,
            eventTimeFormat: { hour: '2-digit', minute: '2-digit', hour12: false },
            customButtons: {
                next: { click: this.nextWeek.bind(this), },
                prev: { click: this.prevWeek.bind(this), },
                customButton: {
                  text: translated_key_1,
                  click: this.handleCustomButtonClick.bind(this)
                }
            },
            headerToolbar: {
              left: 'prev,next today',
              center: 'title',
              right: 'customButton'
            },
            buttonText: {
              today: translated_key_2,
            }
          };
          this.initialCalendarSetup = false;
        }); 
      });
    }

    this.calendarOptions.slotMinTime = minimumHour.toDate().getHours().toString().padStart(2, '0') + ':' + minimumHour.toDate().getMinutes().toString().padStart(2, '0');
    this.calendarOptions.slotMaxTime = maximumHour.toDate().getHours().toString().padStart(2, '0') + ':' + maximumHour.toDate().getMinutes().toString().padStart(2, '0');
    this.calendarOptions.events = events || [];
  }

  private addEvents(events: any[]) {
    events.forEach(element => {
      if(this.fullCalendarApi !== undefined){ this.fullCalendarApi.addEvent(element); }
    });

    if(this.fullCalendarApi !== undefined){ this.fullCalendarApi.render(); }
  }

  private async loadCalendarEvents(periodicScheduleGroupsAvailabilityArgs: PeriodicScheduleGroupsAvailabilityArgs, loadHolidays: boolean = true): Promise<void> {
    this.previousMinimumHourInView = this.minimumHourInView; this.previousMaximumHourInView = this.maximumHourInView;
    this.addingEvents = []; this.minimumHourInView = undefined; this.maximumHourInView = undefined;

    await new Promise<void>((resolve) => {
      if(loadHolidays) {
        this.holidayService.retrieveAllHolidays(this.paginationArgs).subscribe(next => {
          this.holidayData = next.content!.items;

          for (var i = 0; i < this.holidayData?.length!; i++) {
            var start = new Date(this.holidayData![i].date!)
            start!.setHours(0); start!.setMinutes(0); start!.setMilliseconds(0)

            var end = new Date(this.holidayData![i].date!)
            end!.setHours(23);end!.setMinutes(59); end!.setMilliseconds(0)

            const event = {
              title: this.translate('holiday') + `${this.holidayData![i].name}`,
              display: 'background', color: '#75736e', textColor: '#000',
              start: start, end: end,
            };

            this.holidayEvents.push(event);
          }
          if(this.holidayEvents.length > 0){
            this.currentEvents.push(...this.holidayEvents);
          }
        });
      }

      this.scheduleService.retrievePeriodicScheduleEntries(periodicScheduleGroupsAvailabilityArgs).subscribe(result => {
        if(result.status === AdministrationResultStatus.Success && result.content){
          this.periodicScheduleEntriesResultData = result.content;
          this.cyclicPeriodLength = result.content.periodLength ?? 0;
          this.preloadAmount = result.content.preloadAmount ?? 0;

          if(this.firstLoadedStartDate === undefined || result.content.startDate! < this.firstLoadedStartDate){ this.firstLoadedStartDate = result.content.startDate; }
          if(this.lastLoadedEndDate === undefined || result.content.endDate! > this.lastLoadedEndDate){ this.lastLoadedEndDate = result.content.endDate; }

          let periodicScheduleEntries!: { [key: string]: PeriodicScheduleEntryData[]; };

          if((result.content?.periodicScheduleEntryDateRanges?.length ?? 0) > 0) {
            result.content?.periodicScheduleEntryDateRanges?.forEach((entry) => {

              if(this.minimumHourInView === undefined || moment(entry.minHourInRange) < this.minimumHourInView){
                this.minimumHourInView = moment(entry.minHourInRange);
                this.previousMinimumHourInView = this.minimumHourInView;
              }

              if(this.maximumHourInView === undefined || moment(entry.maxHourInRange) > this.maximumHourInView){
                this.maximumHourInView = moment(entry.maxHourInRange);
                this.previousMaximumHourInView = this.maximumHourInView;
              }

              periodicScheduleEntries = entry.periodicScheduleEntries! as { [key: string]: PeriodicScheduleEntryData[]; };

              Object.keys(periodicScheduleEntries).forEach((key) => {
                let selectedDay = periodicScheduleEntries[key] as PeriodicScheduleEntryData[];

                selectedDay.forEach((periodicScheduleEntry) => {
                  var startDate = moment(key).utc(true);
                  startDate.set('hour', periodicScheduleEntry.startingFrom?.getHours()!);
                  startDate.set('minutes', periodicScheduleEntry.startingFrom?.getMinutes()!);

                  var endDate = moment(key).utc(true);
                  endDate.set('hour', periodicScheduleEntry.endOn?.getHours()!);
                  endDate.set('minutes', periodicScheduleEntry.endOn?.getMinutes()!);

                  var color = this.getColorByKey(periodicScheduleEntry.startingFrom?.getHours()!+periodicScheduleEntry.startingFrom?.getMinutes()!+periodicScheduleEntry.startingFrom?.getHours()!+periodicScheduleEntry.endOn?.getMinutes()!)

                  let title:string = "";
                  let employeeCount = periodicScheduleEntry.employees!.length ?? 0;

                  let diffModifier = Math.abs(Math.floor((endDate.utc(true).toDate().getHours() - startDate.utc(true).toDate().getHours()) + ((endDate.utc(true).toDate().getMinutes() - startDate.utc(true).toDate().getMinutes()) / 60)));

                  for(let i=0; i < employeeCount; i++)
                  {
                    if(i == 0 && employeeCount > 1 && i+2 > (diffModifier > 0 ? Math.floor((TITLE_LIMIT * diffModifier) * 0.5) : TITLE_LIMIT)){
                      title = `${employeeCount} ` + this.translate('Employees').toLowerCase();
                      break;
                    } else if(i+1 <= (diffModifier > 0 ? Math.floor((TITLE_LIMIT * diffModifier) * 0.5) : TITLE_LIMIT)){
                      title += periodicScheduleEntry.employees![i].name + " " + periodicScheduleEntry.employees![i].surname + "\n";
                    } else {
                        title += `+ ${employeeCount - i} ${this.translateService.instant('other')}${employeeCount - i > 1 ? this.translateService.instant('plural_modifier') : ''}`;
                        break;
                      }
                  }

                  const event = {
                    title: title, html: true,
                    placement: 'center', container: 'body',
                    start: startDate.utc(true).toDate(), end: endDate.utc(true).toDate(),
                    color: color, textColor: '#000',
                    extendedProps: {
                      description:
                      periodicScheduleEntry.employees !== undefined && periodicScheduleEntry.employees?.length > 0 ?
                        periodicScheduleEntry.employees?.length > 1
                        ? periodicScheduleEntry.employees!.map((employee) => employee.employeeProfileId).join(COMMON_SPLITTER)
                        : COMMON_SPLITTER + periodicScheduleEntry.employees![0].employeeProfileId
                      : ''
                    },
                    eventContent: function(arg:any) {
                      return { html: arg.event.title.replace(/\n/g, '<br>') }
                    },
                  };

                  this.addingEvents.push(event);
                  this.currentEvents.push(event);
                });
              });
            });
            resolve();
          } else resolve();
        } else {
          resolve();
        }
      });
    });
  }

  private async generateCalendar(periodicScheduleGroupsAvailabilityArgs: PeriodicScheduleGroupsAvailabilityArgs, loadHolidays = true): Promise<void> {
    await new Promise<void>(async (resolve) => {
      if(periodicScheduleGroupsAvailabilityArgs.startDate){
        await this.loadCalendarEvents(periodicScheduleGroupsAvailabilityArgs, loadHolidays).then(() => {
          if(!(this.currentEvents.length > 0 && this.minimumHourInView && this.maximumHourInView)){
            if (this.previousMinimumHourInView !== undefined && this.previousMaximumHourInView !== undefined) {
              this.minimumHourInView = this.previousMinimumHourInView;
              this.maximumHourInView = this.previousMaximumHourInView;
            } else {
              if(this.configurationParameterData?.workingHours){
                let workingHours = this.configurationParameterData?.workingHours;
                let minimumWorkingHour: Date | undefined = undefined;
                let maximumWorkingHour: Date | undefined = undefined;

                workingHours.forEach((workingHour) => {
                  if(minimumWorkingHour === undefined || workingHour.fromTime! < minimumWorkingHour){ minimumWorkingHour = workingHour.fromTime; }
                  if(maximumWorkingHour === undefined || workingHour.toTime! > maximumWorkingHour){ maximumWorkingHour = workingHour.toTime; }
                });

                this.minimumHourInView = moment(minimumWorkingHour);
                this.maximumHourInView = moment(maximumWorkingHour);
              } else {
                this.minimumHourInView = moment(new Date()); this.minimumHourInView.set('hour', 0); this.minimumHourInView.set('minute', 0);
                this.maximumHourInView = moment(new Date()); this.maximumHourInView.set('hour', 23); this.maximumHourInView.set('minute', 59);
              }
            }
          }
          resolve();
        }).then(() => {
          this.updateCalendarOptions(this.minimumHourInView ?? moment(new Date()), this.maximumHourInView ?? moment(new Date()), this.currentEvents);
        });
      } else {
        resolve();
      }
    });
  }

  public async nextWeek(): Promise<void> {
    await new Promise<void>(async (resolve) => {
      if(this.periodicScheduleEntriesResultData != undefined){
        if(this.periodicScheduleEntriesResultData.startDate != undefined
          && this.periodicScheduleEntriesResultData.recommendedUpcomingPreloadStartDate != undefined
          && this.lastLoadedEndDate !== undefined){
          let nextStartDate = moment(this.fullCalendarApi !== undefined ? this.fullCalendarApi.view.activeStart : new Date()).add(this.cyclicPeriodLength, 'days').toDate();

          let nextStartDateCompare = new Date(nextStartDate.getFullYear(), nextStartDate.getMonth(), nextStartDate.getDate());
          let lastLoadedEndDateCompare = new Date(this.lastLoadedEndDate.getFullYear(), this.lastLoadedEndDate.getMonth(), this.lastLoadedEndDate.getDate());

          if (nextStartDateCompare >= lastLoadedEndDateCompare){
            this.periodicScheduleGroupsAvailabilityArgs.startDate = moment(lastLoadedEndDateCompare).utc(true).add(1, 'days').toDate();
            this.periodicScheduleGroupsAvailabilityArgs.endDate = moment(lastLoadedEndDateCompare).utc(true).add(this.preloadAmount * this.cyclicPeriodLength, 'days').toDate();

            if(this.initialNextLoad){ this.initialNextLoad = false; }

            await this.loadCalendarEvents(this.periodicScheduleGroupsAvailabilityArgs, false).then(() => {
              if(this.minimumHourInView !== undefined  && this.maximumHourInView !== undefined){
                this.updateCalendarOptions(this.minimumHourInView ?? moment(new Date()), this.maximumHourInView ?? moment(new Date()), this.currentEvents);
              }
              this.addEvents(this.addingEvents);
            }).finally(() => {
              resolve();
            });
          } else resolve();
        } else resolve();
      } else resolve();
    }).finally(() => {
      if(this.fullCalendarApi !== undefined){ this.fullCalendarApi.next(); }
    });
  }

  public async prevWeek(): Promise<void> {
    await new Promise<void>(async (resolve) => {
      if(this.periodicScheduleEntriesResultData !== undefined){
        if(this.periodicScheduleEntriesResultData.startDate !== undefined && this.firstLoadedStartDate !== undefined){
          let previousStartDate = moment(this.fullCalendarApi !== undefined ? this.fullCalendarApi.view.activeStart : new Date()).subtract(this.cyclicPeriodLength, 'days').toDate();

          let previousStartDateCompare = new Date(previousStartDate.getFullYear(), previousStartDate.getMonth(), previousStartDate.getDate());
          let lastLoadedStartDateCompare = new Date(this.firstLoadedStartDate.getFullYear(), this.firstLoadedStartDate.getMonth(), this.firstLoadedStartDate.getDate());

          if (previousStartDateCompare < lastLoadedStartDateCompare){
            this.periodicScheduleGroupsAvailabilityArgs.startDate = moment(lastLoadedStartDateCompare).utc(true).subtract((this.preloadAmount + 1) * this.cyclicPeriodLength, 'days').toDate();
            this.periodicScheduleGroupsAvailabilityArgs.endDate = moment(lastLoadedStartDateCompare).utc(true).subtract(1, 'days').toDate();

            await this.loadCalendarEvents(this.periodicScheduleGroupsAvailabilityArgs, false).then(() => {
              if(this.minimumHourInView !== undefined  && this.maximumHourInView !== undefined){
                this.updateCalendarOptions(this.minimumHourInView ?? moment(new Date()), this.maximumHourInView ?? moment(new Date()), this.currentEvents);
              }
              this.addEvents(this.addingEvents);
            }).finally(() => {
              resolve();
            });
          } else resolve();
        } else resolve();
      } else resolve();
    }).finally(() => {
      if(this.fullCalendarApi !== undefined){ this.fullCalendarApi.prev(); }
    });
  }

  public refreshCalendar() {
    this.generateCalendar(this.periodicScheduleGroupsAvailabilityArgs, false);
  }

  public handleDayRender(dayRenderInfo: any) {
    const sundayIndex = 0; // Sunday is the first day of the week in FullCalendar
    const currentDayIndex = dayRenderInfo.date.getDay();

    if (currentDayIndex === sundayIndex) {
      dayRenderInfo.dayEl.classList.add('fc-disabled-day');
    }
  }

  public handleDateSelect(selectInfo: any) {
    const selectedStartDate = selectInfo.start;
    const selectedEndDate = selectInfo.end;

    // Save the selected date range to the component property
    this.selectedDateRange = { start: selectedStartDate, end: selectedEndDate };
  }

  public handleDateClick(arg: any) {
    this.arg = arg;
    this.allowEmployeeSwap = true;

    if (arg.event._def.ui.display == "background") { //If it's a holiday we don't open the popup, holidays are display:background events
      return;
    }

    this.internalPreviewPopupStartTime = moment(arg.el.fcSeg.start).utc(false).toDate();
    this.internalPreviewPopupEndTime = moment(arg.el.fcSeg.end).utc(false).toDate();

    let todayDate = new Date()
    if (arg.el.fcSeg.start < todayDate) {  //Don't allow changes in the past days
      if (!(arg.el.fcSeg.start.getDate() == todayDate.getDate() &&
          arg.el.fcSeg.start.getMonth() == todayDate.getMonth() &&
          arg.el.fcSeg.start.getFullYear() == todayDate.getFullYear())) {
        //allow if its the same day, irrelevant of time
        this.allowEmployeeSwap = false;
      }
    }

    let employeeProfileIdsString = arg.el.fcSeg.eventRange.def.extendedProps.description.toString();
    let employeeProfileIdsList: number[] = [];
    let date = new Date(arg.el.fcSeg.start);
    date.setUTCHours(0); date.setMinutes(0); date.setMilliseconds(0)

    employeeProfileIdsString.split(COMMON_SPLITTER)?.forEach((employeeProfileId: string) => {
      if(!isNaN(Number(employeeProfileId))){
        employeeProfileIdsList.push(Number(employeeProfileId));
      }
    });

    if(employeeProfileIdsList.length > 0){
      this.employeeService.retrieveAllUsers(3, date).subscribe((data) => {//Get employees that can be replaced
        if(data.content !== undefined && data.content !== null && data.content.items !== undefined && data.content.items !== null && data.content.items.length > 0){
          this.replacedEmployeeData = data.content.items.filter(x => employeeProfileIdsList.includes(x.profileId!));
          this.replacementEmployeeData = data.content.items;
          this.filteredReplacementEmployeeData = data.content.items;

          if(this.replacedEmployeeData !== undefined && this.replacedEmployeeData.length === 1){
            if(this.replacementEmployeeData !== undefined && this.replacementEmployeeData.length > 0){
              this.filteredReplacementEmployeeData = this.replacementEmployeeData?.filter(x => x.profileId !== this.replacedEmployeeData![0].profileId);
            } this.hasChoseEmployeeToReplace = true;
          }
        }
      });
    
      this.replaceEmployeeData!.fromDate = arg.el.fcSeg.start;
      this.replaceEmployeeData!.toDate = arg.el.fcSeg.end;
  
      this.toggleEditShiftPopup();
    }
  }

  public handleCustomButtonClick() {
    this.toggleAddShiftPopup();
  }

  public groupWorkingHourConfigs() {
    this.sortedWorkingHours = {};
    
    this.shiftTemplateData?.forEach((shiftTemplate, index_i) => {
      this.sortedWorkingHours[index_i] = {} as  { [key: number]: WorkDayConfigData[][]; };
      if(shiftTemplate.workWeekList !== undefined){
        shiftTemplate.workWeekList.forEach((workWeek, index_j) => {
          if(workWeek.workDaysConfig !== undefined){
            let workDayConfigs: WorkDayConfigData[] = [];

            Object.keys(workWeek.workDaysConfig).forEach((day) => {
              let selectedDayConfigs = workWeek.workDaysConfig![day] as WorkDayConfigData[];
              if(selectedDayConfigs !== undefined){
                let workDayConfig: WorkDayConfigData = new WorkDayConfigData({
                  dayOfWeek: selectedDayConfigs[0].dayOfWeek,
                  fromTime: selectedDayConfigs[0].fromTime,
                  toTime: selectedDayConfigs[selectedDayConfigs.length - 1].toTime,
                  working: selectedDayConfigs[0].working,
                });

                workDayConfigs.push(workDayConfig);
              }
            });

            this.sortedWorkingHours[index_i][index_j] = [];
            const currentWorkingHours = workDayConfigs.filter((config) => config.working ?? true == true);

            let sortedWorkingHoursGroup: WorkDayConfigData[] = [currentWorkingHours[0]];

            if (currentWorkingHours.length > 1) {
              for (let i = 1; i < currentWorkingHours.length; i++) {
                let currentWorkingHour = sortedWorkingHoursGroup[sortedWorkingHoursGroup.length - 1];
                let comparingWorkingHour = currentWorkingHours[i];

                if(comparingWorkingHour && currentWorkingHour && currentWorkingHour.dayOfWeek && comparingWorkingHour.dayOfWeek) {
                  if (Math.abs(currentWorkingHour.dayOfWeek - comparingWorkingHour.dayOfWeek) === 1 &&
                  currentWorkingHour.fromTime?.getUTCHours() === comparingWorkingHour.fromTime?.getUTCHours() 
                  && currentWorkingHour.fromTime?.getUTCMinutes() === comparingWorkingHour.fromTime?.getUTCMinutes() 
                  && currentWorkingHour.toTime?.getUTCHours() === comparingWorkingHour.toTime?.getUTCHours() 
                  && currentWorkingHour.toTime?.getUTCMinutes() === comparingWorkingHour.toTime?.getUTCMinutes()) {
                    sortedWorkingHoursGroup.push(comparingWorkingHour);
                  } else {
                    this.sortedWorkingHours[index_i][index_j].push(sortedWorkingHoursGroup);
                    sortedWorkingHoursGroup = [comparingWorkingHour];
                  }
                }
              }
            }   

            this.sortedWorkingHours[index_i][index_j].push(sortedWorkingHoursGroup);
          }
        });
      }
    });
  }

  public employeeSelectionChange(event: any) {
    this.employeeProfileId = event.value === null ? undefined : event.value;
    this.addingEvents = []; this.currentEvents = [...this.holidayEvents];

    this.firstLoadedStartDate = this.getLastMonday(moment(this.fullCalendarApi !== undefined ? this.fullCalendarApi.getDate() : new Date()).subtract(this.cyclicPeriodLength, 'days').toDate());
    this.lastLoadedEndDate = this.getLastDayOfWeek(this.firstLoadedStartDate);

    if(this.periodicScheduleEntriesResultData?.startDate) {
      this.periodicScheduleEntriesResultData.startDate = this.firstLoadedStartDate ?? new Date();
    }

    this.periodicScheduleGroupsAvailabilityArgs.employeeProfileId = this.employeeProfileId;
    this.refreshCalendar();
  }
  //#endregion

  //#region Formating and Text
  public formatDate(date: string | Date | undefined): string | undefined {
    if (!date) {
      return undefined;
    }

    const formattedDate = new Date(date).toISOString();

    return formattedDate;
  }

  private getLastMonday(date: Date): Date {
    if (date.getDay() === 1) return date;

    let daysUntilLastMonday = date.getDay() - 1;
    if (daysUntilLastMonday < 0) {
        daysUntilLastMonday += 7;
    }

    const lastMonday = new Date(date.getTime());
    lastMonday.setDate(date.getDate() - daysUntilLastMonday);
    return lastMonday;
  }

  private getLastDayOfWeek(date: Date): Date {
    if (date.getDay() === 0) return date;
    const lastDayOfWeek = new Date(date.getTime());
    lastDayOfWeek.setDate(date.getDate() - date.getDay() + 7);
    return lastDayOfWeek;
  }

  public changeEmployeeShift() {
    this.priorityWorkDayConfigService.replaceEmployeeWithAddingPriorityWDC(this.replaceEmployeeData).subscribe(next => {
      if (next == AdministrationResultStatus.PriorityDayAlreadyExists) {
        this.showConfirmation = true;
      }
      else {
        this.snackBarService.callSnackBar(next, "Successfully entered");
        this.dialog.closeAll();
        window.location.reload();
      }
      this.refreshCalendar()
    });
  }

  public removeEmployeeShift() {
    this.priorityWorkDayConfigService.addPriorityWorkDayConfig(this.replaceEmployeeData?.replacedEmployeeProfileId, new AddPriorityWorkDayConfig({
      forDate: moment(this.replaceEmployeeData?.fromDate).utc(true).clone().toDate(),
      fromTime: this.replaceEmployeeData?.fromDate,
      toTime: this.replaceEmployeeData?.toDate,
      working: false
    })).subscribe(next => {
      if (next == AdministrationResultStatus.PriorityDayAlreadyExists) {
        this.showConfirmation = true;
      }
      else {
        this.snackBarService.callSnackBar(next, "Successfully entered");
       
        setTimeout(() => {
          this.EditShiftPopup.handleClose();
          this.ngAfterViewInit();
        }, 250);
      }
      this.refreshCalendar();
    });
  }

  public getRandomPastelColor() {
    const minSaturation = 35;
    const maxSaturation = 40;
    const minLightness = 75;
    const maxLightness = 85;

    let hue, saturation, lightness, color;

    do {
        hue = getRandomInRange(0, 360);
        saturation = getRandomInRange(minSaturation, maxSaturation);
        lightness = getRandomInRange(minLightness, maxLightness);

        color = `hsla(${hue},${saturation}%,${lightness}%,${DEFAULT_OPACITY})`;
    } while (this.generatedColors.has(color));

    this.generatedColors.add(color);
    if (this.generatedColors.size > MAX_STORED_COLORS) {
        this.generatedColors.delete(Array.from(this.generatedColors)[0]);
    }

    return color;
  }

  public getColorByKey(key: number) {
    if (this.employeeColorMap[key]) {
      return this.employeeColorMap[key];
    }

    const color = this.getRandomPastelColor();
    this.employeeColorMap[key] = color;
    return color;
  }

  public calculateColumns(numElements: number): number {
    if (numElements <= 3) { return 1;  }
    else if (numElements <= 6) { return numElements % 2 == 0 ? 2 : 3; }
    else if (numElements <= 8) { return 4; }
    else if (numElements <= 9) { return 3; }
    else { return Math.ceil(Math.sqrt(numElements)); }
  }
  //#endregion
}
